import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  

   

btnBox:{
marginTop:20,



},
box:{
    marginTop:20,
    
}




}));

